import {useContext, useState, useEffect} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {containsXss} from "../../../utils/security/XssFilter";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import {OAUTH} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from './ProfileSelectModal.module.css';
import EditModal from "../../Account/commponet/modal/EditModal";


/**
 * 테넌트 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
const DEFAULT_IMG = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export default function ProfileSelectModal({ onSelect, onClose, onAdd }) {

    const [profiles, setProfiles] = useState([]);
    const [selectedIdx, setSelectedIdx] = useState(null);

    useEffect(() => {

        axios.get(OAUTH + "/userinfo").then((res) => {
            setProfiles(res.data.sub_profile || []);
        });
    }, []);

  return (
    <>
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.title}>테넌트에서 사용할 프로필 선택</h3>
                    <button className={styles.popCloseBtn} onClick={onClose} />
                </div>
                <div className={styles.profileList}>
                    <div className={styles.infoBox}>
                        <p>하나의 계정은 여러 프로필을 가질 수 있습니다.<br/>
                        선택한 프로필이 해당 테넌트에 오너로 등록됩니다.</p>
                    </div>
                    {profiles.map((profile, idx) => (
                        <div
                        key={idx}
                        className={`${styles.profileItem} ${selectedIdx === idx ? styles.selected : ""}`}
                        onClick={() => setSelectedIdx(idx)}
                        >
                        <div className={styles.profileImage}>
                            <img src={profile.profile_img_url || DEFAULT_IMG} alt="profile" />
                        </div>
                        <div className={styles.profileName}>
                            {profile.profile_name || `프로필 ${idx + 1}`}
                        </div>
                        </div>
                    ))}
                </div>

                {selectedIdx !== null && (
                <button
                    className={styles.confirmButton}
                    onClick={() => onSelect(profiles[selectedIdx])}
                >
                    {profiles[selectedIdx].profile_name || "프로필"} 사용
                </button>
                )}
            </div>
        </div>
    </>
  );
}